import {
  EXPAND_PARTICLE,
  CLOSE_PARTICLE,
  APPLY_CONFIGURATION,
  SET_PARENT_DIMENSIONS,
  SET_PARTICLE_POSITION,
  APP_SCROLLPOSITION_Y,
  SET_LANGUAGE
} from '../actions';

const initialState = {
  open: {},
  read: {1:0}, // set parent Particle as read
  positions: {},
  scrollPosY: 0,
  lang: 'de'
}

const addParticle = ( stateCopy, {id, position}) => {
  stateCopy = {...stateCopy, [id]: position};
  return stateCopy;
}

const removeParticle = ( opened, {id}) => {
  const filtered = Object.keys(opened)
    .filter(key => {
      return key !== id.toString() })
    .reduce((obj, key) => {
      obj[key] = opened[key];
      return obj;
    }, {});
  return filtered;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case APPLY_CONFIGURATION:
      return {
        ...state,
        open: action.configuration
      }
    case EXPAND_PARTICLE:
      return {
        ...state,
        open: addParticle( state.open, action),
        read: addParticle( state.read, action)
      }
    case CLOSE_PARTICLE:
      return {
        ...state,
        open: removeParticle( state.open, action)
      }
    case SET_PARENT_DIMENSIONS:
      return {
        ...state,
        parentTop: action.top,
        parentHeight: action.height
      }
    case SET_PARTICLE_POSITION:
      return {
        ...state,
        positions: addParticle( state.positions, action)
      }
    case APP_SCROLLPOSITION_Y:
      return {
        ...state,
        scrollPosY: action.offset
      }
    case SET_LANGUAGE:
      return {
        ...state,
        lang: action.lang
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/